export enum ISearchType {
    Clinic = 1,
    UserRoleGroup = 2,
    ContractArea = 3,
    CareArea = 4,
    CarePerformerRequest = 5,
    CarePerformer = 6,
    UserCompetence = 7,
    Residence = 8,
    ResidenceRequest = 9
}